// extracted by mini-css-extract-plugin
export default {"imageWrapper":"image-dnd_imageWrapper__wRJz-","description":"image-dnd_description__zhUba","dropzone":"image-dnd_dropzone__mQ7UU","dropzoneOver":"image-dnd_dropzoneOver__P+ON9"};